import AxiosInstance from './config/Http'
import Config from './config/Constants'
import { fetchAllPages } from './config/Pagination'


export const getTicketsByUnitId = async (unitId:string) => AxiosInstance.get(`${Config.core.tickets}?page=0&size=20&status.notEquals=BORRADOR&sort=id,desc&unitId.equals=${unitId}`)


export const getTicket = async (id:string) => AxiosInstance.get(`${Config.core.tickets}/${id}`)

export const getTicketsAll = async (companyID:String | null) =>
  fetchAllPages<any>(`${Config.core.tickets}`, {
    'status.notEquals': 'BORRADOR',
    sort: 'idTicket,desc',
    ...(companyID ? { 'companyID.equals': companyID } : {}),
  })


